/**
 * @generated SignedSource<<698d49f34e710bffcab59faf5fb5a56d>>
 * @relayHash 27a2ffb4f10a1c89ef127341679ca34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd

import type { ConcreteRequest } from 'relay-runtime';
export type ExtensionContextsFilterType = "APP_ID_ENVIRONMENT_ID" | "DATA_CLASSIFICATION_TAG" | "DEFINITION_ID" | "EXTENSION_TYPE" | "PRINCIPAL_TYPE" | "%future added value";
export type ExtensionContextsFilter = {
  type: ExtensionContextsFilterType;
  value: ReadonlyArray<string>;
};
export type useEmitPublicEvent_getExtensionListQuery$variables = {
  contextIds: ReadonlyArray<string>;
  filter: ReadonlyArray<ExtensionContextsFilter>;
};
export type useEmitPublicEvent_getExtensionListQuery$data = {
  readonly extensionContexts: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly appId: string;
      readonly key: string;
      readonly properties: AGG$JSON;
    }>;
  }> | null;
};
export type useEmitPublicEvent_getExtensionListQuery = {
  response: useEmitPublicEvent_getExtensionListQuery$data;
  variables: useEmitPublicEvent_getExtensionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "appId"
},
v4 = {
  "kind": "ScalarField",
  "name": "properties"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmitPublicEvent_getExtensionListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmitPublicEvent_getExtensionListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd",
    "metadata": {},
    "name": "useEmitPublicEvent_getExtensionListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d64f8ab7fa1f6f87512e638d0dec22de";

export default node;
